import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
interface Props {
  title: string;
  children: React.ReactNode;
}

const CollapseComponent = ({ title, children }: Props) => {
  const [isExpand, setExpand] = useState(true);
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#F6F8F9",
          border: "1px solid #EDEFEF",
          borderRadius: "5px",
          boxShadow: "0px 2px 4px rgba(0,0,0,0.16)",
          padding: "20px 30px",
          cursor: "pointer",
        }}
        onClick={() => setExpand((prev) => !prev)}
      >
        <Typography
          sx={{ color: "#1D4A87", fontWeight: "bold", fontSize: "1rem" }}
        >
          {isExpand ? (
            <ArrowDropUpIcon sx={{ fontSize: "28px", marginLeft: "10px" }} />
          ) : (
            <ArrowDropDownIcon sx={{ fontSize: "28px", marginLeft: "10px" }} />
          )}
          {title}
        </Typography>
      </Box>
      {isExpand && (
        <Box
          sx={{
            border: "1px solid #EDEFEF",
            borderRadius: "0px 0px 5px 5px",
            backgroundColor: "#fff",
            padding: "20px 30px",
          }}
        >
          {children}
        </Box>
      )}
    </>
  );
};

export default CollapseComponent;
